export default __webpack_public_path__ + "static/media/7.b55631ce.jpg";